import Cons from '../../isomorphic/cons';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import mobx, { autorun, transaction } from 'mobx';

import DatePicker from 'react-datepicker';
import moment from 'moment';
import { asyncContainer, Typeahead } from 'react-bootstrap-typeahead';
import GoogleAutocomplete from 'react-google-autocomplete';
import Notifications from '../utils/notification-helper';
import { Row } from 'react-bootstrap';
import form from './make-listing-form-component';
import GooglePlacesHelper from '../utils/google-places-helper';

const AsyncTypeahead = asyncContainer(Typeahead);

@inject('appStore')
@observer
export default class MakeListingView extends Component {
    constructor(props) {
        super(props);
        this.form = form(appStore.featureFlagStore);
    }

    updateFieldsFromStore(props) {
        _.each(mobx.toJS(props.appStore.tcFileStore.newListing), (value, key) => {
            this.form.$(key).set(value);
        });
    }
    componentWillMount() {
        this.form.clear();
        this.updateFieldsFromStore(this.props);

        this.form.$('agent').observe(observedChange => {
            if (observedChange.change.newValue.length > 0) {
                const subscriberId = observedChange.change.newValue[0].subscriberId;
                const userId = observedChange.change.newValue[0].agentContactId;

                this.props.appStore.tcFileStore.loadLookupAgentOffices(subscriberId, userId);
                this.props.appStore.tcFileStore.loadLookupAgentPropertyTypes(subscriberId);
            } else {
                this.props.appStore.tcFileStore.clearLookupAgentOffices();
            }
            this.props.appStore.tcFileStore.clearLookupAgentPropertyTypes();
        });

        this.form.$('office').observe(observedChange => {
            observedChange.form.$(`propertyType`).clear();
        });
        const disposer = autorun(() => {
            if (this.props.appStore.tcFileStore.lookupAgentOffices.length == 1) {
                this.form.$('office').set(this.props.appStore.tcFileStore.lookupAgentOffices[0].OfficeId);
            }
        });
    }

    onSave() {
        this.form.validate({ showErrors: true }).then(form => {
            if (form.isValid) {
                // this.props.appStore.analytics.track("New Listing Saved",{ values: this.form.values(), valid:true })
                let formattedFields = {};
                _.each(this.form.values(), (value, key) => {
                    if (form.fields.get(key).$extra === 'date') {
                        if (!moment.isMoment(value)) {
                            value = moment(value);
                        }
                        formattedFields[key] = value.isValid() ? value.format() : null;
                    } else {
                        formattedFields[key] = value;
                    }
                });
                this.props.appStore.listingStore.createNewListing(formattedFields);
            } else {
                // this.props.appStore.analytics.track("New Listing Saved",
                //     { values: this.form.values(), valid:false, errors:form.errors() })
                const errorMessages = _.filter(form.errors(), (value, key) => {
                    return !_.isUndefined(value);
                });
                Notifications.ToastError(errorMessages);
            }
        });
    }

    isEmptyOrSingleOffice() {
        const result =
            this.props.appStore.tcFileStore.lookupAgentOffices.length === 0 ||
            (this.props.appStore.tcFileStore.lookupAgentOffices.length > 0 &&
                _.every(this.props.appStore.tcFileStore.lookupAgentOffices, x => x.IsSingleOfficeBroker));
        return result;
    }

    renderAgentItem = (option, props, index) => {
        return (
            <div key={option.agentContactId}>
                <span>
                    <strong>{option.name}</strong> ({option.email}) {option.company}
                </span>
            </div>
        );
    };

    renderPropertyTypes() {
        const selectedOfficeId = this.form.$(`office`).id;
        const selectedOfficeValue =
            this.props.appStore.tcFileStore.lookupAgentOffices.length > 0 ? parseInt(this.form.$(`office`).value) : 0;
        let i = 0;
        // adding this check against undefined to handle the API not rolling out yet.
        // should take it out eventually
        return _.map(
            _.filter(
                this.props.appStore.tcFileStore.lookupAgentPropertyTypes.slice(),
                x =>
                    x.OfficeId === selectedOfficeValue &&
                    x.Type === 'Listing' &&
                    (_.isUndefined(x.IsInChecklistItem) || x.IsInChecklistItem)
            ),
            value => {
                return (
                    <option key={i++} value={value.PropertyTypeId}>
                        {value.Name}
                    </option>
                );
            }
        );
    }

    setFormAddress(address_components) {
        this.form.$(`address1`).clear();
        this.form.$(`address2`).clear();
        this.form.$(`city`).clear();
        this.form.$(`state`).clear();
        this.form.$(`county`).clear();
        this.form.$(`zip`).clear();
        this.form.$(`direction`).clear();
        this.form.$(`unitNum`).clear();

        if (address_components) {
            const parsedAddress = GooglePlacesHelper.parsePlacesAddress(address_components);
            this.form.$(`address1`).set(parsedAddress.streetNumber || '');
            this.form.$(`address2`).set(parsedAddress.streetName || '');
            this.form.$(`city`).set(parsedAddress.city || '');
            this.form.$(`state`).set(parsedAddress.state || '');
            this.form.$(`county`).set(parsedAddress.county || '');
            this.form.$(`zip`).set(parsedAddress.zip || '');
            this.form.$(`direction`).set(parsedAddress.direction || '');
            this.form.$(`unitNum`).set(parsedAddress.unitNum || '');
        }
    }

    render() {
        return (
            <div className="tab-pane active detail-view">
                <form key={`newListing-1`}>
                    <Row>
                        <div className="col-xs-12 col-sm-4">
                            <div className="form-group">
                                <label htmlFor={this.form.$(`fileType`).id}>{this.form.$(`fileType`).label}</label>
                                <select className="form-control" {...this.form.$(`fileType`).bind()} disabled>
                                    {_.map(Cons.fileTypes, (value, key) => {
                                        return (
                                            <option key={key} value={value}>
                                                {key}
                                            </option>
                                        );
                                    })}
                                </select>
                                <p className="form-error">{this.form.$(`fileType`).error}</p>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-8">
                            <div className="form-group">
                                <label htmlFor={this.form.$(`address`).id}>{this.form.$(`address`).label}</label>
                                <GoogleAutocomplete
                                    className={'form-control'}
                                    ref={autoCompleteRef => {
                                        this.input = autoCompleteRef;
                                    }}
                                    onPlaceSelected={place => {
                                        // appStore.analytics.track("New Listing Address Selected",{ selectedPlace:place })

                                        this.setFormAddress(place.address_components);
                                        this.form.$(`address`).set(place.address_components);

                                        const autoRef = this.input.refs.input;
                                        setTimeout(function() {
                                            autoRef.value = '';
                                            autoRef.focus();
                                        }, 10);
                                    }}
                                    types={['address']}
                                    componentRestrictions={{ country: 'us' }}
                                />
                                <p className="form-error">{this.form.$(`address`).error}</p>
                            </div>
                        </div>
                    </Row>
                    <Row>
                        <div className="col-xs-12 col-sm-2">
                            <div className="form-group">
                                <label htmlFor={this.form.$(`address1`).id} className="required">
                                    {this.form.$(`address1`).label}
                                </label>
                                <input className="form-control" {...this.form.$(`address1`).bind()} />
                                <p className="form-error">{this.form.$(`address1`).error}</p>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <div className="form-group">
                                <label htmlFor={this.form.$(`address2`).id} className="required">
                                    {this.form.$(`address2`).label}
                                </label>
                                <input className="form-control" {...this.form.$(`address2`).bind()} />
                                <p className="form-error">{this.form.$(`address2`).error}</p>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <div className="form-group">
                                <label htmlFor={this.form.$(`direction`).id}>{this.form.$(`direction`).label}</label>
                                <input
                                    className="form-control"
                                    {...this.form.$(`direction`).bind()}
                                    onChange={x => {
                                        this.form.$(`direction`).set(x.target.value.toUpperCase());
                                    }}
                                />
                                <p className="form-error">{this.form.$(`direction`).error}</p>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <div className="form-group">
                                <label htmlFor={this.form.$(`unitNum`).id}>{this.form.$(`unitNum`).label}</label>
                                <input className="form-control" {...this.form.$(`unitNum`).bind()} />
                                <p className="form-error">{this.form.$(`unitNum`).error}</p>
                            </div>
                        </div>
                    </Row>
                    <Row>
                        <div className="col-xs-12 col-sm-3">
                            <div className="form-group">
                                <label htmlFor={this.form.$(`city`).id} className="required">
                                    {this.form.$(`city`).label}
                                </label>
                                <input className="form-control" {...this.form.$(`city`).bind()} />
                                <p className="form-error">{this.form.$(`city`).error}</p>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-3">
                            <div className="form-group">
                                <label htmlFor={this.form.$(`state`).id} className="required">
                                    {this.form.$(`state`).label}
                                </label>

                                <select className="form-control" {...this.form.$(`state`).bind()}>
                                    <option value="">Select a State</option>
                                    {_.map(Cons.states, (value, key) => {
                                        return (
                                            <option key={key} value={key}>
                                                {value}
                                            </option>
                                        );
                                    })}
                                </select>

                                <p className="form-error">{this.form.$(`state`).error}</p>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-3">
                            <div className="form-group">
                                <label htmlFor={this.form.$(`county`).id}>{this.form.$(`county`).label}</label>
                                <input className="form-control" {...this.form.$(`county`).bind()} />
                                <p className="form-error">{this.form.$(`county`).error}</p>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-3">
                            <div className="form-group">
                                <label htmlFor={this.form.$(`zip`).id} className="required">
                                    {this.form.$(`zip`).label}
                                </label>
                                <input className="form-control" {...this.form.$(`zip`).bind()} />
                                <p className="form-error">{this.form.$(`zip`).error}</p>
                            </div>
                        </div>
                    </Row>

                    <Row>
                        <div className="col-xs-12 col-sm-7">
                            <div className="form-group">
                                <label htmlFor={this.form.$(`agent`).id} className="required">
                                    {this.form.$(`agent`).label}
                                </label>

                                <AsyncTypeahead
                                    options={appStore.agentStore.lookupAgentsComputed}
                                    labelKey="name"
                                    minLength={3}
                                    filterBy={
                                        () => {
                                            return true;
                                        } /* just return the results rom elastic search */
                                    }
                                    onSearch={appStore.agentStore.loadLookupAgents}
                                    renderMenuItemChildren={this.renderAgentItem.bind(this)}
                                    onChange={x => {
                                        // appStore.analytics.track("New Listing Agent Selected",{ selectedAgent:x })
                                        this.form.$(`agent`).set(x);
                                    }}
                                    selected={this.form.$(`agent`).value ? this.form.$(`agent`).value : []}
                                />

                                <p className="form-error">{this.form.$(`agent`).error}</p>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-5 date-control">
                            <div className="form-group">
                                <label
                                    htmlFor={this.form.$(`listingDate`).id}
                                    style={{ display: 'block' }}
                                    className="required"
                                >
                                    {this.form.$(`listingDate`).label}
                                </label>

                                <DatePicker
                                    fixedHeight                                    
                                    className="form-control"
                                    style={{ display: 'inline-block' }}
                                    dateFormat="L"
                                    id={this.form.$('listingDate').id}
                                    selected={
                                        this.form.$('listingDate').value
                                            ? moment(this.form.$('listingDate').value)
                                            : null
                                    }
                                    onChange={this.form.$('listingDate').sync}
                                    disabled={this.form.$('listingDate').disabled || false}
                                />

                                <p className="form-error">{this.form.$(`listingDate`).error}</p>
                            </div>
                        </div>
                    </Row>
                    <Row>
                        <div className="col-xs-12 col-sm-6">
                            <div className="form-group">
                                <label htmlFor={this.form.$(`office`).id}>{this.form.$(`office`).label}</label>
                                <select
                                    className="form-control"
                                    {...this.form.$(`office`).bind()}
                                    disabled={this.isEmptyOrSingleOffice()}
                                >
                                    <option value="-1">Select a Type</option>
                                    {_.map(this.props.appStore.tcFileStore.lookupAgentOffices, value => {
                                        return (
                                            <option key={value.OfficeId} value={value.OfficeId}>
                                                {value.OfficeName}
                                            </option>
                                        );
                                    })}
                                </select>
                                <p className="form-error">{this.form.$(`office`).error}</p>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <div className="form-group">
                                <label htmlFor={this.form.$(`propertyType`).id} className="required">
                                    {this.form.$(`propertyType`).label}
                                </label>
                                <select
                                    className="form-control"
                                    {...this.form.$(`propertyType`).bind()}
                                    disabled={this.props.appStore.tcFileStore.lookupAgentPropertyTypes.length <= 0}
                                >
                                    <option value="-1">Select a Type</option>
                                    {this.renderPropertyTypes()})}
                                </select>
                                <p className="form-error">{this.form.$(`propertyType`).error}</p>
                            </div>
                        </div>
                    </Row>
                    <Row>
                        {/*Form Actions*/}
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-actions">
                            <button
                                type="button"
                                className="btn btn-primary pull-right"
                                onClick={this.onSave.bind(this)}
                            >
                                Save
                            </button>
                            <button
                                type="button"
                                className="btn btn-default pull-right"
                                onClick={() => {
                                    // this.props.appStore.analytics.track("New Listing Canceled",{ })
                                    this.props.appStore.viewStore.openFilesPage();
                                }}
                            >
                                Cancel
                            </button>
                            <p className="form-error">{this.form.error}</p>
                        </div>
                    </Row>
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/files/make-listing-detail-view.js